
import React from 'react';
import { motion } from 'framer-motion';

const Privacy = () => {
  return (
    <div className="min-h-screen bg-neutral-50">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-primary-600 to-primary-700 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center"
          >
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              Datenschutzerklärung
            </h1>
            <p className="text-xl text-primary-100 max-w-3xl mx-auto">
              Information about data protection and privacy at Trbe
            </p>
          </motion.div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="bg-white rounded-xl shadow-lg p-8"
          >
            <div className="prose max-w-none">
              <div className="space-y-6 text-neutral-700">
                <div>
                  <h2 className="text-2xl font-bold text-neutral-900 mb-4">1. Datenschutz auf einen Blick</h2>
                  
                  <h3 className="text-lg font-semibold text-neutral-900 mb-2">Allgemeine Hinweise</h3>
                  <p>
                    Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können. Ausführliche Informationen zum Thema Datenschutz entnehmen Sie unserer unter diesem Text aufgeführten Datenschutzerklärung.
                  </p>

                  <h3 className="text-lg font-semibold text-neutral-900 mb-2 mt-4">Datenerfassung auf dieser Website</h3>
                  <p>
                    <strong>Wer ist verantwortlich für die Datenerfassung auf dieser Website?</strong><br />
                    Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können Sie dem Abschnitt „Hinweis zur Verantwortlichen Stelle" in dieser Datenschutzerklärung entnehmen.
                  </p>
                </div>

                <div>
                  <h2 className="text-2xl font-bold text-neutral-900 mb-4">2. Hosting</h2>
                  <p>
                    Wir hosten die Inhalte unserer Website bei externen Dienstleistern (Hosting-Provider). Die personenbezogenen Daten, die auf dieser Website erfasst werden, werden auf den Servern der Hosting-Provider gespeichert. Hierbei kann es sich v. a. um IP-Adressen, Kontaktanfragen, Meta- und Kommunikationsdaten, Vertragsdaten, Kontaktdaten, Namen, Websitezugriffe und sonstige Daten, die über eine Website generiert werden, handeln.
                  </p>
                </div>

                <div>
                  <h2 className="text-2xl font-bold text-neutral-900 mb-4">3. Allgemeine Hinweise und Pflichtinformationen</h2>
                  
                  <h3 className="text-lg font-semibold text-neutral-900 mb-2">Datenschutz</h3>
                  <p>
                    Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend den gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.
                  </p>

                  <h3 className="text-lg font-semibold text-neutral-900 mb-2 mt-4">Hinweis zur verantwortlichen Stelle</h3>
                  <p>
                    Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:<br /><br />
                    <strong>Trbe UG (haftungsbeschränkt)</strong><br />
                    Rheinstr. 46<br />
                    12161 Berlin<br />
                    Deutschland<br /><br />
                    Telefon: +49 (0) 30 1234 5678<br />
                    E-Mail: hello@trbe.ai
                  </p>
                </div>

                <div>
                  <h2 className="text-2xl font-bold text-neutral-900 mb-4">4. Datenerfassung auf dieser Website</h2>
                  
                  <h3 className="text-lg font-semibold text-neutral-900 mb-2">Kontaktformular</h3>
                  <p>
                    Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
                  </p>
                  <p>
                    Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage mit der Erfüllung eines Vertrags zusammenhängt oder zur Durchführung vorvertraglicher Maßnahmen erforderlich ist. In allen übrigen Fällen beruht die Verarbeitung auf unserem berechtigten Interesse an der effektiven Bearbeitung der an uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO) oder auf Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) sofern diese abgefragt wurde.
                  </p>
                </div>

                <div>
                  <h2 className="text-2xl font-bold text-neutral-900 mb-4">5. Ihre Rechte</h2>
                  <p>
                    Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem ein Recht, die Berichtigung oder Löschung dieser Daten zu verlangen. Wenn Sie eine Einwilligung zur Datenverarbeitung erteilt haben, können Sie diese Einwilligung jederzeit für die Zukunft widerrufen. Außerdem haben Sie das Recht, unter bestimmten Umständen die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen. Des Weiteren steht Ihnen ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.
                  </p>
                  <p>
                    Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können Sie sich jederzeit an uns wenden.
                  </p>
                </div>

                <div>
                  <h2 className="text-2xl font-bold text-neutral-900 mb-4">6. Kontakt</h2>
                  <p>
                    Bei Fragen zum Datenschutz wenden Sie sich bitte an:<br /><br />
                    <strong>Trbe UG (haftungsbeschränkt)</strong><br />
                    Datenschutzbeauftragter<br />
                    Rheinstr. 46<br />
                    12161 Berlin<br />
                    Deutschland<br /><br />
                    E-Mail: privacy@trbe.ai<br />
                    Telefon: +49 (0) 30 1234 5678
                  </p>
                </div>

                <div className="text-sm text-neutral-500 pt-6 border-t border-neutral-200">
                  <p>Stand: Januar 2025</p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Privacy;
